import { render, staticRenderFns } from "./ZoomMeet.vue?vue&type=template&id=52d50b40&scoped=true"
import script from "./ZoomMeet.vue?vue&type=script&lang=js"
export * from "./ZoomMeet.vue?vue&type=script&lang=js"
import style0 from "./ZoomMeet.vue?vue&type=style&index=0&id=52d50b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d50b40",
  null
  
)

export default component.exports